
import {
    FacebookLogo, PlayCircle, LinkedinLogo, InstagramLogo, XLogo, YoutubeLogo,
} from '@phosphor-icons/react';


export const headermenu = [
    { title: 'Home', to: '/' },
    { title: 'Ouvir rádio', to: '/ouvir-radio-online', Icon: PlayCircle, iconColor: '' },
    { title: 'Promoções', to: '/promocoes' },
    // { title: 'Podcasts', to: '/podcasts' }, // Archived with the /podcasts routes.
    { title: 'Comercial', to: 'https://comercial.antena1.com.br/' },
    // { title: 'Publicidade', to: '/anuncie-conosco', textColor: '#09b100' }, // #30558f (blue) // temporarly disabled as the publicidade page is also disabled and we will improve the anuncie conosco page
];

export const social = [
    { title: 'Facebook', to: 'https://www.facebook.com/Antena1.BR', Icon: FacebookLogo },
    { title: 'Twitter', to: 'https://twitter.com/Antena_1', Icon: XLogo },
    { title: 'Instagram', to: 'https://www.instagram.com/antena1/', Icon: InstagramLogo },
    { title: 'Linkedin', to: 'https://www.linkedin.com/company/radioantena1/', Icon: LinkedinLogo },
    { title: 'Youtube', to: 'http://www.youtube.com/Antena1Brasil', Icon: YoutubeLogo },

];
